<template>
  <div class="of-hidden">
    <template v-if="listStyle === STYLES.cards">
      <v-skeleton-loader color="transparent" v-bind="$attrs" type="image" class="mb-3 overflow-hidden" />
      <v-skeleton-loader color="transparent" v-bind="$attrs" type="sentences" max-width="320" class="mb-2 bg-transparent" style="margin-top: -16px;" />
      <div class="d-flex" style="margin-top: -10px;">
        <v-skeleton-loader color="transparent" v-bind="$attrs" type="chip" height="24" class="mr-2" />
        <v-skeleton-loader
          v-show="display.smAndUp.value"
          color="transparent"
          v-bind="$attrs"
          type="chip"
          height="24"
          class="mr-2"
        />
        <v-skeleton-loader v-show="display.mdAndUp.value" color="transparent" v-bind="$attrs" type="chip" height="24" />
      </div>
    </template>

    <template v-if="listStyle === STYLES.tiles">
      <div class="d-flex align-start mb-2">
        <v-skeleton-loader
          color="transparent"
          v-bind="$attrs"
          type="image"
          class="flex-grow-1 mr-4 overflow-hidden"
          height="48"
          max-width="150"
        />
        <div class="flex-grow-1" style="margin-top: -12px;">
          <v-skeleton-loader color="transparent" v-bind="$attrs" type="sentences" max-width="320" />
        </div>
      </div>
      <div class="d-flex" style="margin-top: -4px;">
        <v-skeleton-loader color="transparent" v-bind="$attrs" type="chip" height="24" class="mr-2" />
        <v-skeleton-loader
          v-show="display.smAndUp.value"
          color="transparent"
          v-bind="$attrs"
          type="chip"
          height="24"
          class="mr-2"
        />
        <v-skeleton-loader v-show="display.mdAndUp.value" color="transparent" v-bind="$attrs" type="chip" height="24" />
      </div>
    </template>

    <template v-if="listStyle === STYLES.headlines">
      <v-skeleton-loader color="transparent" v-bind="$attrs" type="sentences" max-width="400" class="mb-2 bg-transparent" style="margin-top: -16px;" />
      <div class="d-flex" style="margin-top: -6px;">
        <v-skeleton-loader color="transparent" v-bind="$attrs" type="chip" height="24" class="mr-2" />
        <v-skeleton-loader
          v-show="display.smAndUp.value"
          color="transparent"
          v-bind="$attrs"
          type="chip"
          height="24"
          class="mr-2"
        />
        <v-skeleton-loader v-show="display.mdAndUp.value" color="transparent" v-bind="$attrs" type="chip" height="24" />
      </div>
    </template>

    <template v-if="listStyle === STYLES.list">
      <div class="d-flex align-start">
        <v-skeleton-loader
          color="transparent"
          v-bind="$attrs"
          tile
          height="32"
          max-height="32"
          width="32"
          type="image"
          class="mr-4 overflow-hidden"
          style="height: 32px;"
        />
        <div class="flex-grow-1">
          <v-skeleton-loader
            color="transparent"
            v-bind="$attrs"
            type="image"
            class="flex-grow-1 overflow-hidden"
            height="12"
            max-height="12"
            style="height: 12px; margin-bottom: -8px;"
            max-width="100"
          />

          <v-skeleton-loader color="transparent" v-bind="$attrs" type="text" max-width="340" class="mb-2" />
          <div class="d-flex" style="margin-top: -8px;">
            <v-skeleton-loader color="transparent" v-bind="$attrs" type="chip" height="24" class="mr-2" />
            <v-skeleton-loader
              v-show="display.smAndUp.value"
              color="transparent"
              v-bind="$attrs"
              type="chip"
              height="24"
              class="mr-2"
            />
            <v-skeleton-loader v-show="display.mdAndUp.value" color="transparent" v-bind="$attrs" type="chip" height="24" />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue'
import { useDisplay } from 'vuetify'
import { ITEM_LAYOUT_STYLE } from '@/utils/constants'

defineProps({
  listStyle: {
    type: String,
    required: true,
  },
})

const display = useDisplay()

const STYLES = computed(() => {
  return ITEM_LAYOUT_STYLE
})
</script>

<script>
// Using normal script block to set options
export default {
  inheritAttrs: true,
}
</script>

<style lang="scss" scoped>
.v-skeleton-loader {
  :deep(.v-skeleton-loader__chip) {
    height: 24px !important;
    width: 94px !important;
    border-radius: 12px !important;
    margin: 0px !important;
  }

  :deep(.v-skeleton-loader__text) {
    margin-left: 0 !important;
  }

  :deep(.v-skeleton-loader__bone) {
    padding: 0 !important;
  }
}
</style>
